module.exports = __webpack_public_path__ + "static/media/login.c35ddc8b.png";